export const defaultEntranceExamMinimumScorePct = '50';
